module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<div class="icon">\n  <% if (display.iconUrl) { %>\n  <image src="<%= display.iconUrl %>" alt="<%= display.title %>"/>\n<% } else { %>\n  <global-menu-generic-icon data-name="<%= display.title %>" data-length="2">\n  </global-menu-generic-icon>\n<% } %>\n</div>\n\n<div class="path">\n  <% if (display.grandparent) { %>\n  <div class="context">\n    <p class="context-name"><%= display.grandparent %></p>\n    <%- icons.chevron %>\n  </div>\n  <% }%>\n  <% if (display.parent) { %>\n  <div class="context">\n    <p class="context-name"><%= display.parent %></p>\n    <%- icons.chevron %>\n  </div>\n  <% }%>\n  <div class="context">\n    <p class="context-name"><%= display.title %></p>\n  </div>\n</div>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<div class="icon">\n  ');
                __stack.lineno = 2;
                if (display.iconUrl) {
                    buf.push('\n  <image src="', escape((__stack.lineno = 3, display.iconUrl)), '" alt="', escape((__stack.lineno = 3, display.title)), '"/>\n');
                    __stack.lineno = 4;
                } else {
                    buf.push('\n  <global-menu-generic-icon data-name="', escape((__stack.lineno = 5, display.title)), '" data-length="2">\n  </global-menu-generic-icon>\n');
                    __stack.lineno = 7;
                }
                buf.push('\n</div>\n\n<div class="path">\n  ');
                __stack.lineno = 11;
                if (display.grandparent) {
                    buf.push('\n  <div class="context">\n    <p class="context-name">', escape((__stack.lineno = 13, display.grandparent)), "</p>\n    ", (__stack.lineno = 14, icons.chevron), "\n  </div>\n  ");
                    __stack.lineno = 16;
                }
                buf.push("\n  ");
                __stack.lineno = 17;
                if (display.parent) {
                    buf.push('\n  <div class="context">\n    <p class="context-name">', escape((__stack.lineno = 19, display.parent)), "</p>\n    ", (__stack.lineno = 20, icons.chevron), "\n  </div>\n  ");
                    __stack.lineno = 22;
                }
                buf.push('\n  <div class="context">\n    <p class="context-name">', escape((__stack.lineno = 24, display.title)), "</p>\n  </div>\n</div>\n");
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/cam-context-switcher/templates/cam-context-switcher.ejs
// module id = 135
// module chunks = 0 1